import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import RouteFallback from "../RouteFallback";
import { checkPasswordResetSession } from "../../services/loginInfo";
import { needsPasswordChange } from "./authUtils";

/**
 * Allows /change-password when either:
 * - first-time login (JWT is_pwd_changed === false), or
 * - a valid password-reset cookie session (forgot-password flow).
 */
export default function ChangePasswordRoute() {
  const [sessionState, setSessionState] = useState("loading"); // loading | valid | invalid

  useEffect(() => {
    let isMounted = true;

    if (needsPasswordChange()) {
      setSessionState("valid");
      return () => {
        isMounted = false;
      };
    }

    checkPasswordResetSession()
      .then((isValid) => {
        if (isMounted) {
          setSessionState(isValid ? "valid" : "invalid");
        }
      })
      .catch(() => {
        if (isMounted) {
          setSessionState("invalid");
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (sessionState === "loading") {
    return <RouteFallback />;
  }

  if (sessionState === "invalid") {
    return <Navigate to="/forgot-password" replace />;
  }

  return <Outlet />;
}
